import { Alert, Grid, Typography } from '@mui/material';
import { PendingReviewEvacZoneErrorType } from 'features/geoEvents/geoEvent.types';
import { Trans } from 'react-i18next';

type PendingEvacZonesErrorProps = {
  zoneNames: string;
  type: PendingReviewEvacZoneErrorType;
};

export const PendingEvacZonesError = (
  props: PendingEvacZonesErrorProps,
): JSX.Element | null => {
  const { zoneNames, type } = props;

  if (type === 'not-accepted') {
    return (
      <Grid size={12}>
        <Alert severity="error">
          <Typography>
            <Trans
              i18nKey="pendingEvacZonesWarning.error.notAccepted"
              values={{ zones: zoneNames }}
            >
              You must accept changes to these pending review zones in order to
              change their statuses:
              <b>{zoneNames}</b>
            </Trans>
          </Typography>
        </Alert>
      </Grid>
    );
  }

  if (type === 'restricted-with-status') {
    return (
      <Grid size={12}>
        <Alert severity="error">
          <Typography>
            <Trans
              i18nKey="pendingEvacZonesWarning.error.restrictedWithStatus"
              values={{ zones: zoneNames }}
            >
              You must remove statuses from <b>{zoneNames}</b> to accept pending
              zone changes.
            </Trans>
          </Typography>
        </Alert>
      </Grid>
    );
  }

  return null;
};
